import './App.css';

function App() {
  return (
    <div className="App">
      Welcome to Suhrits space in web.
    </div>
  );
}

export default App;
